class CountdownTimer extends HTMLElement {
  connectedCallback() {
    this.targetDate = new Date(this.dataset.target);

    if (isNaN(this.targetDate.getTime())) {
      this.remove();
      return;
    }

    this.startDate = this.dataset.start ? new Date(this.dataset.start) : null;
    if (this.startDate && isNaN(this.startDate.getTime())) {
      this.startDate = null;
    }

    this.daysEl = this.querySelector('[data-unit="days"]');
    this.hoursEl = this.querySelector('[data-unit="hours"]');
    this.minutesEl = this.querySelector('[data-unit="minutes"]');
    this.secondsEl = this.querySelector('[data-unit="seconds"]');

    this.tick();
    this.interval = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  tick() {
    const now = Date.now();

    if (this.startDate && now < this.startDate.getTime()) {
      this.classList.add('is-not-started');
      return;
    }
    this.classList.remove('is-not-started');

    const remaining = this.targetDate.getTime() - now;
    const clamped = Math.max(0, remaining);

    let diff = clamped;
    const days = Math.floor(diff / 86400000);
    diff -= days * 86400000;
    const hours = Math.floor(diff / 3600000);
    diff -= hours * 3600000;
    const minutes = Math.floor(diff / 60000);
    diff -= minutes * 60000;
    const seconds = Math.floor(diff / 1000);

    this.updateUnit(this.daysEl, days);
    this.updateUnit(this.hoursEl, hours);
    this.updateUnit(this.minutesEl, minutes);
    this.updateUnit(this.secondsEl, seconds);

    if (remaining <= 0) {
      clearInterval(this.interval);
      this.classList.add('is-expired');
    }
  }

  updateUnit(el, value) {
    if (!el) return;
    const formatted = String(value).padStart(2, '0');
    if (el.textContent === formatted) return;
    el.textContent = formatted;
    el.classList.remove('is-ticking');
    void el.offsetWidth;
    el.classList.add('is-ticking');
  }
}

customElements.define('countdown-timer', CountdownTimer);
